import { useCore } from "@/core-nextv3/core/core";
import type { ISetting } from "@/core-nextv3/util/setting";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";

export const useProtectedAuthMeta = (
	_setting: ISetting,
	successUrl?: string,
	failUrl?: string,
) => {
	const { user } = useContext(AuthContext);
	const router = useRouter();
	const [loadProtectedAuth, setPoadProtectedAuth] = useState(false);
	const { isLoadingUser } = useCore();

	useEffect(() => {
		if (!isLoadingUser) {
			if (user) {
				if (successUrl && successUrl === "back") {
					router.back();
				} else if (successUrl) {
					router.push(successUrl);
				} else {
					setPoadProtectedAuth(true);
				}
			} else {
				if (failUrl) {
					router.push(failUrl);
				} else {
					setPoadProtectedAuth(true);
				}
			}
		}
	}, [isLoadingUser]);

	return loadProtectedAuth;
};
